import type React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Link from "@mui/material/Link";
import styles from "../styles";
import useCss from "../../../../hooks/useCss";

interface Resource {
  url: string;
  name: string;
}

interface ResourcesRowProps {
  row: Record<string, unknown> & { resources?: Resource[] };
}

const ResourcesRow = ({ row }: ResourcesRowProps) => {
  const classes = useCss(styles);
  const linkRenderer = (resource: Resource) => {
    const newTab = window.open(resource.url, "_blank", "noopener,noreferrer");
    newTab?.focus();
  };
  return (
    <>
      <TableRow>
        <TableCell className={classes.headerCellRoot}>
          {String(row.name ?? "")}
        </TableCell>
      </TableRow>
      {row.resources &&
        row.resources.map((resource, index) => {
          return (
            <TableRow key={index} className={classes.detailRowRoot}>
              <TableCell className={classes.detailCellRoot}>
                <Link
                  component={"a"}
                  href={resource.url}
                  onClick={(e: React.MouseEvent) => {
                    e.preventDefault();
                    linkRenderer(resource);
                  }}
                >
                  {resource.name}
                </Link>
              </TableCell>
            </TableRow>
          );
        })}
    </>
  );
};

export default ResourcesRow;
